/* AULBERY — Product info rows (modal panels, native <dialog>)
   Moved 1:1 from the inline <script> in snippets/as-product-accordion.liquid.
   Root: [data-as-acc] (the row list). Its dialogs are siblings, found by the
   per-section class dialog.asa-dialog-<data-as-acc-section>. */
(function () {
  function initAcc(root) {
    if (!root || root.dataset.asaInit === '1') return;
    root.dataset.asaInit = '1';

    var sectionId = root.dataset.asAccSection || '';
    var dialogs = Array.prototype.slice.call(
      document.querySelectorAll('dialog.asa-dialog-' + sectionId)
    );

    function dialogFor(key) {
      for (var i = 0; i < dialogs.length; i++) {
        if (dialogs[i].dataset.asaModal === key) return dialogs[i];
      }
      return null;
    }

    function openDialog(dlg) {
      if (!dlg) return;
      if (typeof dlg.showModal === 'function') {
        if (!dlg.open) dlg.showModal();
      } else {
        // very old browser: plain open, still usable
        dlg.setAttribute('open', '');
      }
    }

    function closeDialog(dlg) {
      if (!dlg) return;
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }

    root.querySelectorAll('[data-asa-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDialog(dialogFor(btn.dataset.asaOpen));
      });
    });

    dialogs.forEach(function (dlg) {
      // X button
      dlg.querySelectorAll('[data-asa-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeDialog(dlg);
        });
      });

      // click outside the panel closes (backdrop clicks land on the dialog)
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) closeDialog(dlg);
      });

      // size guide button inside the fit dialog
      dlg.querySelectorAll('[data-asa-guide]').forEach(function (el) {
        el.addEventListener('click', function () {
          // close this one first so the two are never stacked in the top
          // layer, then hand over on the very next frame — a timer here
          // showed as a gap between the two modals
          closeDialog(dlg);
          if (el.dataset.asaGuideMode === 'page') {
            window.requestAnimationFrame(function () {
              openDialog(dialogFor('guide'));
            });
            return;
          }
          window.requestAnimationFrame(function () {
            document.dispatchEvent(new CustomEvent('as:size-guide'));
          });
        });
      });
    });

    // nothing global is registered (only element listeners and one-shot
    // frames), so there is nothing to release beyond the init flag
    root.asAccDestroy = function () {
      delete root.dataset.asaInit;
    };
  }

  function initAll() {
    document.querySelectorAll('[data-as-acc]').forEach(initAcc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (e) {
    var section = e && e.target;
    if (!section || !section.querySelectorAll) return;
    section.querySelectorAll('[data-as-acc]').forEach(function (root) {
      if (typeof root.asAccDestroy === 'function') root.asAccDestroy();
    });
  });
})();

